import { render, staticRenderFns } from "./LocationFormItem.vue?vue&type=template&id=12589310&scoped=true&"
import script from "./LocationFormItem.vue?vue&type=script&lang=js&"
export * from "./LocationFormItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../BougeMaVille-reborn-client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12589310",
  null
  
)

export default component.exports